import React from "react";
import ItemAvatar from "../../../components/ItemAvatar";

const DetailStockOpname = ({ stockOpname, closeModal }) => (
  <div
    className="modal modal-blur fade"
    id="modal-detail-stock-opname"
    tabIndex="-1"
    role="dialog"
    aria-hidden="false"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <div>
            <h5 className="modal-title">Detail Stock Opname</h5>
            <div className="text-secondary">{stockOpname.opname_no || "-"}</div>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          <div className="row mb-3">
            <div className="col-md-3">
              <div className="text-secondary">Tanggal</div>
              <div className="fw-bold">{stockOpname.opname_date || "-"}</div>
            </div>
            <div className="col-md-3">
              <div className="text-secondary">Status</div>
              <span className={`badge ${stockOpname.status === "completed" ? "bg-success-lt" : "bg-warning-lt"}`}>
                {stockOpname.status === "completed" ? "Completed" : "Draft"}
              </span>
            </div>
            <div className="col-md-6">
              <div className="text-secondary">Catatan</div>
              <div>{stockOpname.note || "-"}</div>
            </div>
          </div>
          <div className="table-responsive border rounded">
            <table className="table table-vcenter mb-0">
              <thead className="table-header">
                <tr>
                  <th>No.</th>
                  <th>Tipe</th>
                  <th>Item</th>
                  <th className="text-center">Stok Sistem</th>
                  <th className="text-center">Stok Fisik</th>
                  <th className="text-center">Selisih</th>
                  <th>Catatan</th>
                </tr>
              </thead>
              <tbody>
                {(stockOpname.details || []).map((detail, index) => (
                  <tr key={detail.id || `${detail.item_type}-${detail.item_id}`}>
                    <td>{index + 1}.</td>
                    <td className="text-capitalize">{detail.item_type === "product" ? "Produk" : "Material"}</td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <ItemAvatar name={detail.item_name} image={detail?.image_path || detail?.image} size="sm" />
                        <span className="fw-bold">{detail.item_name}</span>
                      </div>
                    </td>
                    <td className="text-center">
                      {detail.system_stock} {detail.unit}
                    </td>
                    <td className="text-center">
                      {detail.physical_stock} {detail.unit}
                    </td>
                    <td className="text-center">
                      <span
                        className={`badge ${detail.difference === 0 ? "bg-success-lt" : detail.difference > 0 ? "bg-blue-lt" : "bg-danger-lt"}`}>
                        {detail.difference > 0 ? "+" : ""}
                        {detail.difference}
                      </span>
                    </td>
                    <td>{detail.note || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary ms-auto" data-bs-dismiss="modal">
            Tutup
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default DetailStockOpname;
